import React from 'react';

import { View } from 'react-native';

import { useIsDesktopLargeBreakpoint } from 'hooks/use-media-query';
import { useLocale } from 'state/intl';
import { t } from 'state/intl/translations';

import { FooterCCPAButtonLink, FooterText, FooterWrapper } from './footer.styled';

export const Footer = () => {
  const { region } = useLocale();
  const isDesktopLarge = useIsDesktopLargeBreakpoint();
  return (
    <FooterWrapper>
      <View focusable>
        <FooterText>
          {t('trademarkAndCopyright', { year: String(new Date().getFullYear()) })}{' '}
          {t('allRightsReserved')}
        </FooterText>
      </View>
      {isDesktopLarge && region === 'US' && <FooterText> | </FooterText>}
      {region === 'US' && <FooterCCPAButtonLink isUnderlined isInline={isDesktopLarge} />}
    </FooterWrapper>
  );
};
